<div class="container-fluid">

    @for (b of budget; track b; let i = $index) {
    <div>
        <table [attr.id]="'table'+i" mat-table [dataSource]="b" class="mat-elevation-z8">
            <!-- Name/Type of Column -->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                <td mat-footer-cell *matFooterCellDef> Total </td>
            </ng-container>
            <!-- Quantity Column -->
            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef> Quantité </th>
                <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <!-- Cost Column -->
            <ng-container matColumnDef="unitcost">
                <th mat-header-cell *matHeaderCellDef> Prix unitaire </th>
                <td mat-cell *matCellDef="let element"> {{element.unitcost | currency}} </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <!-- Line total -->
            <ng-container matColumnDef="totalPerline">
                <th mat-header-cell *matHeaderCellDef> Total </th>
                <td mat-cell *matCellDef="let element"> {{element.quantity * element.unitcost | currency}} </td>
                <td mat-footer-cell *matFooterCellDef> {{getTotalCost(b) | currency}} </td>
            </ng-container>
            <ng-container matColumnDef="parent-name">
                <th style="background-color: darkkhaki;" mat-header-cell *matHeaderCellDef colspan="4">
                    <div class="d-flex justify-content-between align-items-center">
                        <span></span>
                        <span class="fw-bold text-center">
                            {{ getParentName(b) }}
                        </span>
                        <button class="" mat-raised-button color="accent" (click)="addPump(b, i)">
                            <mat-icon class="material-symbols-outlined"> add</mat-icon>
                            Ajouter une pompe
                        </button>
                    </div>
                </th>
            </ng-container>
            <!-- Disclaimer column -->
            <ng-container matColumnDef="disclaimer">
                <td mat-footer-cell *matFooterCellDef colspan="4">
                    Please note that the cost of items displayed are completely and totally made up.
                </td>
            </ng-container>
            <ng-container matColumnDef="big-total1">
                <td mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="big-total2">
                <td mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="big-total3">
                <td mat-footer-cell *matFooterCellDef> Total estimatif </td>
            </ng-container>
            <ng-container matColumnDef="big-total4">
                <td mat-footer-cell *matFooterCellDef> {{ getGrandTotal() | currency}}</td>
            </ng-container>
            <!-- The table will render two header rows, one data row per data object, and two footer rows. -->
            @if (i === 0) {
            <span>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            </span>
            }
            <tr mat-header-row *matHeaderRowDef="['parent-name']"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            @if (i === budget.length - 1) {
            <span>
                <tr mat-footer-row *matFooterRowDef="['big-total1', 'big-total2', 'big-total3', 'big-total4']"></tr>
                <tr mat-footer-row *matFooterRowDef="['disclaimer']"></tr>
            </span>
            }
        </table>
    </div>
    }
</div>